export default __webpack_public_path__ + "static/media/image28.67158a55.svg";